namespace TabAurous.Production {
    export interface WorkOrderItemsForm {
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: Serenity.LookupEditor;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: StoneSizeLookup;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        Remarks: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: WorkOrderBOMEditor;
    }

    export class WorkOrderItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.WorkOrderItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkOrderItemsForm.init)  {
                WorkOrderItemsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.BooleanEditor;
                var w6 = s.DecimalEditor;
                var w7 = WeightEditor;
                var w8 = StoneSizeLookup;
                var w9 = StoneSieveLookup;
                var w10 = s.ImageUploadEditor;
                var w11 = WorkOrderBOMEditor;

                Q.initFormType(WorkOrderItemsForm, [
                    'ItemTypeId', w0,
                    'ProductId', w1,
                    'ProductTypeId', w2,
                    'ProductCode', w1,
                    'ProductName', w1,
                    'AttributeId', w1,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'ProductSizeId', w2,
                    'HasBom', w5,
                    'MetalId', w2,
                    'Attribute', w1,
                    'KaratId', w2,
                    'Purity', w6,
                    'PureWeight', w7,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w8,
                    'SieveId', w9,
                    'GroupSieveId', w9,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w1,
                    'StoneDepth', w1,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'Pieces', w0,
                    'Weight', w7,
                    'Line_No', w1,
                    'HSN', w2,
                    'TaxCode', w2,
                    'NetWeight', w7,
                    'DiamondPieces', w0,
                    'DiamondWeight', w7,
                    'StonePieces', w0,
                    'StoneWeight', w7,
                    'OtherPieces', w0,
                    'OtherWeight', w7,
                    'Remarks', w1,
                    'ImageName', w10,
                    'BOMDetails', w11
                ]);
            }
        }
    }
}
